import { query, } from "@lookiero/messaging";
const VIEW_GAME_BY_CUSTOMER_ID = "view_game_BY_CUSTOMER_ID_by_customer_id";
const viewGameByCustomerId = (payload) => ({
    ...query({ name: VIEW_GAME_BY_CUSTOMER_ID }),
    ...payload,
});
const viewGameByCustomerIdHandler = ({ view, signal }) => async ({ customerId }) => view({ customerId, signal });
export { VIEW_GAME_BY_CUSTOMER_ID, viewGameByCustomerId, viewGameByCustomerIdHandler };
